var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-M"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,113.5c-1,0-2-0.4-2.7-1.2l-32-32l-32,32c-0.7,0.7-1.7,1.1-2.7,1.1c-1,0-2-0.4-2.7-1.1 c-0.7-0.7-1.1-1.6-1.1-2.6c0-1,0.4-2,1.1-2.8l32-32l-32-32c-1.5-1.5-1.5-3.9,0-5.4c0.7-0.7,1.7-1.1,2.7-1.1c1,0,2,0.4,2.7,1.1 l32,32l32-32c0.7-0.7,1.7-1.1,2.7-1.1c1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7c0,1-0.4,2-1.1,2.8l-32,32l32,32 c1.5,1.5,1.5,3.9,0,5.3C111.7,113.1,110.7,113.5,109.7,113.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHClose);
export default __webpack_public_path__ + "static/media/h_close.a895fdf9937be8bfd30795b4e38772a4.svg";
export { ForwardRef as ReactComponent };